import React from 'react';
import { Box, Typography } from '../ui';

/**
 * GroupSettingsRow
 *
 * Two-column layout primitive for the group editor's General + Branding
 * tabs: title/description on the left, controls on the right (stacks on
 * mobile). Shared between GroupGeneralTab and GroupBrandingTab so the two
 * tabs read with one visual language.
 */
export default function GroupSettingsRow({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children: React.ReactNode;
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: { xs: 1.5, md: 4 },
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: { xs: 'stretch', md: 'flex-start' },
        py: 3,
      }}
    >
      <Box sx={{ width: { xs: '100%', md: 280 }, flexShrink: 0 }}>
        <Typography variant="subtitle2" fontWeight={700}>
          {title}
        </Typography>
        {description && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.25 }}>
            {description}
          </Typography>
        )}
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
    </Box>
  );
}
